export const PREFIX       = 'wphack';
export const CLOSE_FRAME  = `${PREFIX.toUpperCase()}:IFRAME_CLOSE`;

